import { Controller } from "stimulus";

export default class extends Controller {
  play() {
    const { mediaUrl, mediaName } = this.element.dataset;
    $(".modal-title.media-player").html(
      mediaName.substring(0, mediaName.length - 4)
    );
    $(".media-player").attr("src", mediaUrl);
  }

  connect() {
    $(document).on("hide.bs.modal", () => {
      $(".media-player").trigger('pause');
      $(".media-player").currentTime = 0
    });
  }
}
